import { useEffect, useState } from 'react';
import { APP_VERSION } from '../version';

export function useVersionCheck() {
  const [needsUpdate, setNeedsUpdate] = useState(false);

  useEffect(() => {
    async function checkVersion() {
      try {
        // Add cache-busting headers and query parameter
        const response = await fetch(`/version.json?_=${Date.now()}`, {
          cache: 'no-cache',
          headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
          }
        });

        if (!response.ok) return;
        
        const { version } = await response.json();
        if (version !== APP_VERSION) {
          setNeedsUpdate(true);
        }
      } catch (error) {
        console.error('Error checking version:', error);
      }
    }

    // Check immediately and then every minute
    checkVersion();
    const interval = setInterval(checkVersion, 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  return needsUpdate;
}